export default {
  stripeSubscription: 'Stripe',
  mobilePaySubscription: 'MobilePay',
  byAdmin: 'Created by admin'
}